import { domReady } from "@roots/sage/client";

import Alpine from "alpinejs";
import scroll from "./scroll-direction";

import "../views/blocks/portfolio/portfolio";
import "../views/blocks/quotes/quotes";
import "../views/blocks/news/news";
import "../views/blocks/team/team";
import "../views/blocks/approach/approach";
import "../views/blocks/arrow/arrow";
import "../views/blocks/headline/headline";
import "../views/blocks/hero-landing/hero-landing";
import "../views/blocks/hero/hero";
import "../views/blocks/hero-alternative/hero-alternative";
import "../views/blocks/heritage/heritage";
import AOS from "aos";

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);

Alpine.plugin(scroll);
window.Alpine = Alpine;
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  AOS.init();
});
